import * as $ from "jquery";

export default class ScrollSpy {

	checkBodySections() {
		const currentTop = $(document).scrollTop();

		$('.scrollspy-watch').each((i, el) => {
			if ($(el).offset().top <= currentTop + (window.innerHeight / 2)) {
				$(el).addClass("scrollspy-active");
			} else {
				$(el).removeClass("scrollspy-active");
			}
		});
	}
}